import { render } from "./ReportDetailsModal.vue?vue&type=template&id=7dc99706&scoped=true"
import script from "./ReportDetailsModal.vue?vue&type=script&lang=js"
export * from "./ReportDetailsModal.vue?vue&type=script&lang=js"

import "./ReportDetailsModal.vue?vue&type=style&index=0&id=7dc99706&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc99706"]])

export default __exports__